import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Ordini',
  buttons: {
    actions: 'Azioni',
    [action_create_dummy_order]: 'Crea ordine di prova',
    [action_launch_orders_portal_app]: 'Apri portale ordini',
    show_order_details: 'Mostra dettagli ordine',
    track_order: 'Traccia ordine',
    update_dropoff_time: 'Aggiorna orario di consegna',
    download_receipt: 'Scarica ricevuta',
    open_payment_page: 'Apri pagina di pagamento',
  },
  form: {
    customer_details: {
      placeholder: 'Inserisci nome cliente o numero di telefono',
    },
    amount_min: {
      placeholder: 'Importo min.',
    },
    amount_max: {
      placeholder: 'Importo max.',
    },
    utm_source: {
      placeholder: 'Inserisci utm source',
    },
    utm_medium: {
      placeholder: 'Inserisci utm medium',
    },
    utm_campaign: {
      placeholder: 'Inserisci utm campaign',
    },
    utm_advertisement_id: {
      placeholder: 'Inserisci utm advertisement id',
    },
  },
  labels: {
    // A table order's table under its method: "Table 7"; names like "Terrace 2" show as they are.
    table_numbered: 'Tavolo {{name}}',
    no_orders: 'Nessun ordine ancora',
    total_orders: 'Ordini totali',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Ritiro',
    [ORDER_METHODS.delivery]: 'Consegna',
    [ORDER_METHODS.on_site]: 'Ordini al tavolo',
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'In attesa',
    [ORDER_PAYMENT_STATUSES.paid]: 'Pagato',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Parzialmente rimborsato',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Rimborsato',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'In attesa di approvazione',
      [FULFILLMENT_STATUSES.reviewed]: 'In attesa di approvazione',
      [FULFILLMENT_STATUSES.accepted]: 'In lavorazione',
      [FULFILLMENT_STATUSES.preparing]: 'In lavorazione',
      [FULFILLMENT_STATUSES.ready]: 'In lavorazione',
      [FULFILLMENT_STATUSES.on_delivery]: 'In lavorazione',
      [FULFILLMENT_STATUSES.picked]: 'Completato',
      [FULFILLMENT_STATUSES.rejected]: 'Rifiutato',
      null: 'Sconosciuto',
      undefined: 'Sconosciuto',
    },
  },
  tags: {
    dummy: 'TEST',
    pickup: 'Ritiro',
    internal_delivery: 'Consegna interna',
    external_delivery: 'Consegna esterna',
    on_site: 'Ordini al tavolo',
    scheduled: 'Programmato',
    reward: 'Premio',
    mobile: 'Mobile',
    invoice: 'Fattura',
    cash: 'Contanti',
    rejected_automatically: 'Rifiutato automaticamente',
    rejected_manually: 'Rifiutato manualmente',
    call_center: 'Call center',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Ristorante',
    tags: 'Tag',
    order_placed: 'Ordine effettuato',
    ready_at: 'Ordine pronto',
    customer: 'Cliente',
    items: 'Articoli',
    method: 'Metodo',
    payment_status: 'Stato pagamento',
    fulfillment_status: 'Stato',
    total: 'Totale',
    utm_source: 'UTM Source',
    utm_medium: 'UTM Medium',
    utm_campaign: 'UTM campaign',
    utm_advertisement_id: 'UTM Advertisement Id',
  },
  metrics: {
    total_orders: 'Ordini totali',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_create_dummy_order: 'Creazione ordine di prova non riuscita',
    dummy_order_created: 'Ordine di prova creato',
    failed_to_launch_orders_portal_app: 'Avvio del portale ordini non riuscito',
    failed_to_download_receipt: 'Download della ricevuta non riuscito',
  },
};
